import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ProductSlider = ({ currentProductId, currentCategory }) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const [products, setProducts] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const response = await fetch(`${apiUrl}/products`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        const productsArray = data.products || [];

        // Normalize data
        const normalizedProducts = productsArray.map((item) => {
          const { _id, ...rest } = item;
          return { id: _id, ...rest };
        });

        // Filter: remove current product + keep same category
        const filteredProducts = normalizedProducts
          .filter(
            (product) =>
              String(product.id) !== String(currentProductId)
          )
          .filter((product) => {
            if (!currentCategory) return true;

            const productCategory =
              typeof product.category === "object"
                ? product.category.name
                : product.category;

            return productCategory === currentCategory;
          });

        setProducts(filteredProducts);
      } catch (err) {
        console.error("ProductSlider error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [apiUrl, currentProductId, currentCategory]);

  if (loading) return null;
  if (error) return null;
  if (products.length === 0) return null;

  const settings = {
    dots: false,
    infinite: products.length > 1,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <Slider
      {...settings}
      className="img-carousel-content primary btn-style-1"
    >
      {products.map((item) => (
        <div className="item" key={item.id}>
          <div className="item-box">
            <Link to={`/product-details/${item.id}`}>
              <div className="item-img">
                <img
                  src={apiUrl + item?.images?.[0]}
                  alt={item?.name}
                />
                <div className="item-info-in">
                  <ul>
                    <li>
                      <Link to={`/product-details/${item.id}`}>
                        <i className="ti-eye"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Link>

            <div className="item-info text-center text-black p-a10">
              <h6 className="item-title text-uppercase font-weight-500">
                <Link to={`/product-details/${item.id}`}>
                  {item?.name}
                </Link>
              </h6>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default ProductSlider;
